module.exports = __webpack_public_path__ + "static/media/map-outline-01.a22567e5.svg";